// extracted by mini-css-extract-plugin
export default {"articlesWrapper":"MiniProductsList-module__articlesWrapper--GYE_Z"};